import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import ExternalAuth from '../login/ExternalAuth';

function AppRoute(props) {
  let allowedRoutes = props.routes;

  if (props.routes) {
    const routeCtx = {
      showReports: props.showReports,
      showReportsTRI: props.showReportsTRI,
      coordinator: props.isCoordinator,
      userType: props.userType,
      hasEvaluationWithEssay: props.hasEvaluationWithEssay,
      coordinatorPermission: props.coordinatorPermission,
    };
    allowedRoutes = props.routes.filter(
      (r) => r.allow === undefined || r.allow(routeCtx),
    );
  }

  return (
    <div>
      {props.userType && props.userType !== 4 ? (
        <Route exact path="/" render={() => <Redirect to="/simulated" />} />
      ) : (
        <Route exact path="/" render={() => <Redirect to="/online-simulated" />} />
      )}

      <Route
        path={props.path}
        render={(innerProps) => (
          // pass the sub-routes down to keep nesting
          <props.component {...innerProps} routes={allowedRoutes} />
        )}
      />
      <Route path="/auth" component={ExternalAuth} />
    </div>
  );
}

function mapStateToProps({ login, app }) {
  return {
    showReports: login.showReports,
    showReportsTRI: login.showReportsTRI,
    isCoordinator: login.isCoordinator,
    userType: app.user ? app.user.idType : null,
    hasEvaluationWithEssay: app.user ? app.user.hasEvaluationWithEssay : null,
    coordinatorPermission: login.isCoordinator ? login.isCoordinator.permission : null,
  };
}

export default connect(mapStateToProps)(AppRoute);
